export function isScrolledIntoView(container, element) {
	const cTop = container.scrollTop;
	const cBottom = cTop + container.clientHeight;

	const eTop = element.offsetTop;
	const eBottom = eTop + element.clientHeight;

	const isInView = eTop >= cTop && eBottom <= cBottom;

	return isInView;
}
